import { PLOTTYPE } from "./chartConfig"

interface Window {
  Trading: any
}

declare var window: Window

export const setPlotType = (plotType: string, _controller: any) => {
  if (!_controller || plotType === PLOTTYPE[3].key) return
  switch (plotType) {
    case "candle":
      _controller.Chart.set_ChDataPlot(
        window.Trading.Chart.Proto.Util.candlePlot(
          _controller.Chart.get_ColorF()
        )
      )
      break
    case "line":
      _controller.Chart.set_ChDataPlot(
        window.Trading.Chart.Proto.Util.linePlot(
          5,
          _controller.Chart.get_ColorF()
        )
      )
      break
    case "lineFill":
      _controller.Chart.set_ChDataPlot(
        window.Trading.Chart.Proto.Util.lineFillPlot(
          1,
          _controller.Chart.get_ColorF()
        )
      )
      break
    default:
      break
  }
}

export const setViewType = (plotType: string, _controller: any) => {
  if (!_controller) return
  if (plotType === "PandF") {
    _controller.SetViewType.call(null, { $: 1 })
    return
  }
  _controller.SetViewType.call(null, { $: 0 })
}
